import { ActionIcon, type MantineColor, Tooltip } from "@mantine/core"
import { ReactNode } from "react"
import classes from "./table-action-button.module.css"

export type TableActionButtonProps = {
  icon: ReactNode
  label: string
  onClick: () => void
  color?: MantineColor
  disabled?: boolean
  loading?: boolean
}

export function TableActionButton({
  icon,
  label,
  onClick,
  color = "brand",
  disabled,
  loading,
}: TableActionButtonProps) {
  return (
    <Tooltip label={label} position="bottom" withArrow openDelay={150}>
      <ActionIcon
        variant="light"
        size={36}
        radius="xl"
        color={color}
        onClick={(e) => { e.stopPropagation(); onClick() }}
        disabled={disabled}
        loading={loading}
        className={classes.btn}
      >
        {icon}
      </ActionIcon>
    </Tooltip>
  )
}
